<div class="modal-header">
  <h4 class="modal-title"> {{'finalizationPreviewApproval.title' | translate}}</h4>
</div>

<div class="modal-body pt-0">
  <div class="modal-body-inner overflow-xh" maxHeightOffset="200" style="min-height: 150px;">
    <div *ngIf="!previewURL">
      <span >{{'finalizationPreviewApproval.waitingForCompletion.text' | translate}}</span>
    </div>
    <div *ngIf="previewURL">
      <div >{{'finalizationPreviewApproval.LinkPreface.text' | translate}}</div>
      <div ><a class='green u-hover' href="{{previewURL}}" target="_blank">{{previewURL}}</a></div>
      <div >{{'finalizationPreviewApproval.linkFollowup.text' | translate}}</div>
    </div>
  </div>
</div>

<div class="modal-footer justify-content-between">
  <div class="form-check checkbox me-auto">
  </div>
  <button class="btn btn-secondary btn-cancel" [disabled]="!previewURL" type="button" (click)="declineButtonClickHandler()">{{'finalizationPreviewApproval.declineButton.label' | translate}}</button>
  <button class="btn btn-primary btn-forward" [disabled]="!previewURL"  type="button" (click)="approveButtonClickHandler()">{{'finalizationPreviewApproval.approveButton.label' | translate}}</button>
</div>
